<script setup></script>

<template>
  <button class="group flex w-full items-center rounded-lg px-2 py-2 text-sm text-secondary-600 hover:bg-secondary-100">
    <slot></slot>
  </button>
</template>

<style scoped></style>
